var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('document-processor',{ref:"processor",attrs:{"process":_vm.process,"emptyHisKeys":_vm.emptyHisKeys}})}
var staticRenderFns = []

export { render, staticRenderFns }